import { FindingService, FindingChange } from '@analysis/domain';
import { type FindingRepository } from '../../ports';
import { Finding, FindingParameters } from '@telespot/domain';

export interface SyncFindingsPayload {
  sampleId: string;
  findings: FindingParameters[];
  changedFindings: Map<string, FindingChange>;
}

export class SyncFindingsUseCase {
  constructor(private readonly findingRepository: FindingRepository) {}

  public async execute({ sampleId, findings, changedFindings }: SyncFindingsPayload): Promise<Finding[]> {
    if (changedFindings.size === 0) return [];

    const changedFindingsList = findings.filter((finding) => changedFindings.has(finding.uuid));

    const updatedFindings = changedFindingsList
      .map((findingParams) => {
        const change = changedFindings.get(findingParams.uuid);
        if (change) {
          const finding = new Finding(findingParams);
          return FindingService.applyChange(finding, change);
        }
        return undefined;
      })
      .filter((f): f is Finding => f != null);

    return this.findingRepository.saveAll(updatedFindings, sampleId);
  }
}
